const SHOPIFY_ADMIN_STORE = '77dea0-e1'
const STOREFRONT_PRODUCTS_URL = 'https://shopusars.com/products'

export function storefrontProductUrl(handle: string | null | undefined): string | null {
  const normalized = handle?.trim()
  return normalized ? `${STOREFRONT_PRODUCTS_URL}/${encodeURIComponent(normalized)}` : null
}

export function shopifyAdminProductUrl(productGid: string | null | undefined): string | null {
  const productId = productGid?.match(/^gid:\/\/shopify\/Product\/(\d+)$/)?.[1]
  return productId
    ? `https://admin.shopify.com/store/${SHOPIFY_ADMIN_STORE}/products/${productId}`
    : null
}

export function shopifyAdminCustomerUrl(customerId: string | null | undefined): string | null {
  const id = customerId?.match(/(\d+)$/)?.[1]
  return id ? `https://admin.shopify.com/store/${SHOPIFY_ADMIN_STORE}/customers/${id}` : null
}
